export enum TestUserStatusEnum {
  UPCOMING = 1,
  PENDING = 2,
  STARTED = 3,
  COMPLETED = 4,
  EXPIRED = 5,
}

export enum TestTypesEnum {
  SELF_TEST = "self-test",
  INSTITUTE_TEST = "institute-test",
  SELF_TEST_SERIES = "self-test-series",
  PRELOADED_TEST = "preloaded-test",
  PAST_YEAR_TEST = "past-year-test",
}

export enum QuestionStatusEnum {
  UNSEEN = "unseen",
  UNANSWERED = "unanswered",
  ANSWERED = "answered",
  MARKED_FOR_REVIEW = "markedForReview",
  CURRENT_QUESTION = "currentQuestion",
  CORRECT = "correct",
  INCORRECT = "incorrect",
  SKIPPED = "skipped",
}

export enum EventTypesEnum {
  START_TEST = "start_test",
  RESUME_TEST = "resume_test",
  VIEW_QUESTION = "view_question",
  SELECT_ANSWER = "select_answer",
  INPUT_ANSWER = "input_answer",
  UPLOAD_ANSWER = "upload_answer",
  CLEAR_ANSWER = "clear_answer",
  SUBMIT_ANSWER = "submit_attempt",
  MARK_FOR_REVIEW = "mark_for_review",
  VIEW_TEST_PAPER = "view_test_paper",
  VIEW_TEST_PAPER_CLOSE = "view_test_paper_close",
  INSTRUCTIONS_CONFIRMED = "instructions_confirmed",
  VIEW_INSTRUCTIONS = "view_instructions",
  VIEW_INSTRUCTIONS_CLOSE = "view_instructions_close",
  FULLSCREEN_DISABLED = "fullscreen-disabled",
  END_TEST_POPUP_OPEN = "end_test_popup_open",
  END_TEST_POPUP_CLOSE = "end_test_popup_close",
  USER_END_TEST = "user_end_test",
  END_TEST_SUCCESSFUL = "end_test_successful",
  AUTO_END_TEST_TIMER = "auto-end-test-timer",
  AUTO_END_TEST_FULLSCREEN = "auto-end-test-fullscreen",
}

export enum AffiliationTestReportTabsEnum {
  STUDENT_WISE = "Student-wise",
  QUESTION_WISE = "Question-wise",
}

export enum OfflineTestTabsEnum {
  GENERATE_QUESTION_PAPER = 1,
  GENERATE_OMR = 2,
  UPLOAD_OMR = 3,
  REVIEW_OMR = 4,
}

export enum OmrImageTypeEnum {
  ORIGINAL = 1,
  MARKED = 2,
}

export enum OmrUploadStatusEnum {
  PENDING = 1,
  PROCESSED = 2,
}

export enum OmrStatusEnum {
  SAVED = 1,
  APPROVED = 2,
  REJECTED = 3,
  FINALIZED = 4,
  REVIEW = 5,
  FAILED = 9,
}

export enum OmrReviewStatusEnum {
  APPROVE = 2,
  REJECT = 3,
  REVIEW = 5,
}

export enum OmrFilterEnum {
  ALL = 1,
  PENDING = 2,
  REVIEW = 3,
  VALID = 4,
  INVALID = 5,
}

export enum SelfTestCategoryEnum {
  PENDING = 2,
  STARTED = 3,
  COMPLETED = 4,
}

export enum PastYearPaperPeriodsEnum {
  LAST_3_YEARS = 3,
  LAST_5_YEARS = 5,
  LAST_10_YEARS = 10,
}

export enum PresetTestStatusEnum {
  NEW = 1,
  STARTED = 3,
  COMPLETED = 4,
}
